module.exports = __webpack_public_path__ + "img/ME.ead587ce.svg";